export default __webpack_public_path__ + "static/media/dns.d8b8d850.svg";